<template>
  <div class="flex number-input-select-wrapper">
    <vs-input
      :value="value"
      @input="(e) => $emit('input', e)"
      @change="$emit('change', $event.target.value)"
      type="number"
      class="w-full"
      :disabled="disabled"
    />
    <vs-select
      width="120px"
      :value="unit"
      @input="$emit('update:unit', $event)"
      @change="$emit('change', unit)"
      :disabled="disabled"
    >
      <vs-select-item
        :key="unit"
        :value="unit"
        :text="unit"
        v-for="unit in units"
      />
    </vs-select>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      default: null,
    },
    unit: {
      type: String,
      default: null,
    },
    units: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input", "update:unit", "change"],
};
</script>

<style lang="scss" scoped>
.number-input-select-wrapper::v-deep {
  .vs-input--input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .vs-select--input {
    background-color: #f8f8f8;
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    &:hover {
      background-color: #fbfbfb;
      box-shadow: 0 0 1px 1px #e2e8f0;
    }
  }
}
</style>

